import { useMeContext } from '../api/me-provider.js';
import { SlotRoute } from './slot-route.js';
import { CoachBookHourRoute } from './coach-book-hour-route.js';

/** One hour from Book: the coach's for an MPC coach (stage B), the parent's otherwise. */
export function SlotTab() {
  const { state } = useMeContext();
  if (state.status === 'ready' && state.me.is_mpc_coach) return <CoachBookHourRoute />;
  return <SlotRoute />;
}
